import React from 'react'
import ErrorBoundary from '../../components/molecules/ErrorBoundary'
import LoadingView from '../../components/pages/LoadingView'
import ErrorView from '../../components/pages/ErrorView'
import RestrictedView from '../../components/pages/RestrictedView'
import AcceptTerms from '../../components/pages/accept-terms'
import { useCheckPolicies } from '../../api/policy'
import { usePolicy } from '../../hooks/usePolicy'
import { useUserProfile } from '../shared/useAppShellSetup'
import HelpApp from './index'

function HelpAppShell () {
  const { userProfile, appConfigLoading } = useUserProfile()
  const { isLoading, error } = useCheckPolicies()
  const isAdmin = usePolicy('admin_denali_internal')

  if (userProfile.error) {
    return <ErrorView error={userProfile.error} />
  }

  if (userProfile.isNonInteractive) {
    return <RestrictedView />
  }

  if (!userProfile.isValidTermsAcceptance) {
    return <AcceptTerms />
  }

  if (error) {
    return <ErrorView error='There was an error loading the application' />
  }

  if (isLoading || appConfigLoading) {
    return <LoadingView />
  }

  if (!isAdmin) {
    return <RestrictedView />
  }

  return (
    <ErrorBoundary name='Help application' refresh>
      <HelpApp />
    </ErrorBoundary>
  )
}

export default HelpAppShell
